import { Injectable } from '@angular/core';
import {FormGroup} from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class ReglasNegocioService {

  constructor() { }

  esConyugeCuidador(validador: any, conyuge: any): boolean {
    if (validador?.afiliado?.estado !== "VIGEN" || validador?.afiliado?.afiliacion?.categoria !== "A") {
      return false;
    }
    if (conyuge?.TipoIdConyuge === "CO1L") {
      return false;
    }
    const pacs = validador?.pacs;
    if (Array.isArray(pacs)) {
      for (let i = 0; i < pacs.length; i++) {
        const pac = pacs[i];
        if (pac?.discapacidad === "1" && pac?.estado === "VIGEN") {
          return true;
        }
      }
    }
    return false;
  }

  sonDocumentosValidos(pac: FormGroup): boolean {
    const documentsValid = pac.get('documents')?.value != '' ? pac.get('documents')?.valid : pac.get('documents')?.value != ''; // docemn == "";
    const base64Valid = pac.get('base64Valid')?.valid ?? false;
    const base64Exists = !!pac.get('base64Valid');
    if (documentsValid) return true;
    return !documentsValid && base64Exists && base64Valid;
  }

}
